import axios from '@/axios/config'

export default {
  state: {},
  namespaced: true,
  actions: {
    async getInventoryActions(_store, params) {
      return axios.get('/api/inventory-actions', {
        params,
      })
    },

    async exportMonthlyHistory(_store, payload) {
      const params =
        typeof payload === 'string'
          ? { period: payload }
          : {
              period: payload.period,
              storage_nickname: payload.storage_nickname,
            }

      return axios.get('api/inventory-items/history/export-monthly', {
        params,
        responseType: 'blob',
      })
    },
  },
}
